export const defaultColumns = [
  { label: 'Status', value: 'status' },
  { label: 'Cod Fatura', value: 'number' },
  { label: 'Tipo de Empresa', value: 'client_kind' },
  { label: 'Empresa', value: 'client_info' },
  { label: 'Filial', value: 'client_branch_display_name' },
  { label: 'Limite/Empenho', value: 'credit_info' },
  { label: 'Tipo da Fatura', value: 'bill_kind' },
  { label: 'Vlr. Total', value: 'total_amount', className: 'text-green-400' },
  { label: 'Data de abertura', value: 'opened_at' },
  { label: 'Data de fechamento', value: 'closed_at' },
  { label: 'Data de vencimento', value: 'due_at' },
  { label: 'Ações', value: 'actions', className: 'w-0 p-2' },
]
